<template>
  <div class="history-table-pagination">
    <PtPagination
      class="is-background"
      v-bind="$attrs"
      background
      layout="prev, pager, sizes,next"
      popper-class="popper__no-arrow"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import { Pagination } from 'element-ui';

export default {
    components: {
        PtPagination: Pagination
    }
};
</script>

<style lang="scss">
.history-table-pagination {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 40px;
  .el-pagination .el-select .el-input {
    width: 130px;
  }
  .el-pagination__sizes {
    display: none !important;
  }
  .li {
    margin: 0 5px;
    border: 1px solid #b3bac5;
    border-radius: 4px;
    color: #505f79;
    font-size: 12px;
    font-weight: normal;
    background-color: #fff;
  }
  .el-pagination.is-background {
    .el-pager li {
      @extend .li;
      &.active {
        border-color: #1976d2;
        color: #1976d2;
        background-color: #fff;
        & + li {
          border-left: 1px solid #b3bac5;
        }
      }
      &:hover {
        color: #505f79;
        background-color: #f4f5f7;
      }
      &.disabled {
        color: #bbb;
        background-color: #eef1f6;
      }
      &.more {
        color: #505f79;
        border-color: #fff;
      }
    }
    .btn-prev,
    .btn-next {
      @extend .li;
      &:hover {
        color: #505f79;
        background-color: #f4f5f7;
      }
      &:disabled {
        color: #b3bac5;
        border: 1px solid #f4f5f7;
        background-color: #f4f5f7;
      }
    }
    .el-pagination__sizes {
      margin: -1px 10px 0 50px;
      .el-input .el-input__inner {
        border-radius: 4px;
        border-color: #b3bac5;
        font-size: 12px;
      }
    }
  }
  .el-pagination li.more + li.number,
  .el-pagination li.btn-quicknext + li.number {
    display: none;
  }
  .el-pagination {
    padding-left: 0;
  }
  .btn-prev {
    margin-left: 0 !important;
  }
}
</style>
